import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';
import UserDoc from '../../models/UserDoc';

async function deleteUser(
  userDoc: UserDoc,
  auth: Authentication
): Promise<void> {
  if (
    ![UserRole.owner, UserRole.admin, UserRole.maintainer].includes(auth.role)
  ) {
    throw new DeleteUserFailure('Unauthorized', 'unauthorized');
  }
  try {
    await HttpClient.delete(
      '/user',
      {
        uid: userDoc.uid,
      },
      auth.token
    );
    return;
  } catch (e) {
    console.log('error: ', e);
    throw new DeleteUserFailure();
  }
}

export class DeleteUserFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default deleteUser;
